let lastShownSponsorId: string | null = null

export function getLastShownSplashSponsorId() {
  return lastShownSponsorId
}

export function setLastShownSplashSponsorId(sponsorId: string | null) {
  lastShownSponsorId = sponsorId
}

export function clearLastShownSplashSponsorId() {
  lastShownSponsorId = null
}
